<template>
  <popup-modal ref="popup">
    <div v-if="showParentStatus">
      <DialogCloseButton :close-method="closeDialog" />

      <div>
        <h2 class="font-weight-bold">
          {{ $t('FILE_STEP_GUARANTEE.FORCE_GUARANTEE_MODAL.TITLE') }}
        </h2>
        <div class="my-8" style="text-align: start">
          <p>
            {{ $t('FILE_STEP_GUARANTEE.FORCE_GUARANTEE_MODAL.MESSAGE') }}
          </p>
        </div>
        <div class="my-4" style="text-align: start">
          <p data-custom="true">
            {{ $t('FILE_STEP_GUARANTEE.FORCE_GUARANTEE_MODAL.SUB_TITLE_ONE') }}
          </p>
        </div>
        <v-textarea
          v-model.trim="forcedSupportDescription"
          :placeholder="$t('FILE_STEP_GUARANTEE.FORCE_GUARANTEE_MODAL.PLACEHOLDER.SUB_GUARANTEE')"
          auto-grow
          rows="2"
          :maxlength="100"
          :counter="100"
        />

        <!--Add attachment-->
        <div class="my-4" style="text-align: start">
          <p>
            {{ $t('FILE_STEP_GUARANTEE.FORCE_GUARANTEE_MODAL.SUB_TITLE_TWO') }}
          </p>
        </div>

        <v-row>
          <v-col cols="12" md="6" class="pr-1">
            <v-text-field
              :label="$t('FILE_STEP_GUARANTEE.INPUT_LABEL_BY_QR_CODE')"
              :disabled="currentRepairFile.product_force_support_proof_file_path"
              :hide-details="!error?.forcedSupportFile"
              append-inner-icon="mdi-camera"
              @click="showAddQrCodeAttachment"
            />
          </v-col>
          <v-col cols="12" md="6" class="pl-1">
            <v-text-field
              :label="$t('FILE_STEP_GUARANTEE.INPUT_LABEL_BY_PC')"
              :disabled="currentRepairFile.product_force_support_proof_file_path"
              :hide-details="!error?.forcedSupportFile"
              append-inner-icon="mdi-download"
              @click="showAddPcAttachment()"
            />
          </v-col>
        </v-row>

        <!--Chips file added-->
        <v-row
          class="chip-container pb-3"
          v-if="currentRepairFile.product_force_support_proof_file_path"
        >
          <v-col>
            <v-chip append-icon="mdi-close" class="clickable-chip">
              {{ currentRepairFile.product_force_support_proof_file_path }}
              <template v-slot:append>
                <v-icon
                  @click="removeAttachment(attachmentType, currentRepairFile.technical_id)"
                  class="append-icon"
                >
                  mdi-close
                </v-icon>
              </template>
            </v-chip>
          </v-col>
        </v-row>
        <!--End Add attachment-->

        <div class="d-flex justify-center mt-4">
          <v-btn
            class="boom-button pl-15 pr-15"
            variant="outlined"
            @click="_confirm"
            :disabled="!forcedSupportDescription"
          >
            {{ $t('FILE_STEP_GUARANTEE.FORCE_GUARANTEE_MODAL.BUTTON') }}
          </v-btn>
        </div>
      </div>
    </div>

    <AddAttachmentPcComponent
      v-if="showAddPcAttachmentStatus"
      :current-repair-file-props="currentRepairFile"
      :attachment-file-props="forcedSupportFile"
      :attachment-type-props="attachmentType"
      @back-to-parent-page="handleBackToParentView()"
    />
    <AddAttachmentQRCodeComponent
      v-if="showAddQrCodeAttachmentStatus"
      :current-repair-file-props="currentRepairFile"
      :attachment-file-props="forcedSupportFile"
      :attachment-type-props="attachmentType"
      @back-to-parent-page="handleBackToParentView()"
    />
  </popup-modal>
</template>

<script>
import PopupModal from '../PopupModal.vue'
import RepairFileService from '@/services/RepairFileService'
import { auth as $store } from '@/store/AuthModule'
import ResponseConstant from '@/constants/responseConstant'
import AddAttachmentPcComponent from '@/components/repair-file-module/folder-lifecycle/add-attachment/AddAttachmentPcComponent.vue'
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'
import AddAttachmentQRCodeComponent from '@/components/repair-file-module/folder-lifecycle/add-attachment/AddAttachmentQRCodeComponent.vue'
import DialogCloseButton from '@/components/modal/DialogCloseButton.vue'

export default {
  name: 'EnforceSupportModal',
  components: {
    DialogCloseButton,
    AddAttachmentQRCodeComponent,
    AddAttachmentPcComponent,
    PopupModal
  },
  data: () => ({
    resolvePromise: undefined,
    rejectPromise: undefined,

    showParentStatus: true,
    showAddPcAttachmentStatus: false,
    showAddQrCodeAttachmentStatus: false,

    currentRepairFile: null,
    attachmentType: 'FORCE_SUPPORT_PROOF',
    forcedSupportFile: undefined,
    forcedSupportDescription: undefined,

    error: null
  }),

  methods: {
    show(opts = {}) {
      this.currentRepairFile = opts.currentRepairFile
      this.forcedSupportFile = opts.forcedSupportFile
      this.forcedSupportDescription = opts.forcedSupportDescription

      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm() {
      this.$refs.popup.close()
      this.resolvePromise({
        confirmed: true,
        forcedSupportDescription: this.forcedSupportDescription
      })
    },
    closeDialog() {
      this.$refs.popup.close()
    },
    async handleBackToParentView() {
      this.showParentStatus = true
      this.showAddPcAttachmentStatus = false
      this.showAddQrCodeAttachmentStatus = false

      this.currentRepairFile = await RepairFileService.get(this.currentRepairFile.boomerang_id)
    },
    showAddPcAttachment() {
      this.showParentStatus = false
      this.showAddPcAttachmentStatus = true
      this.showAddQrCodeAttachmentStatus = false
    },
    showAddQrCodeAttachment() {
      this.showParentStatus = false
      this.showAddPcAttachmentStatus = false
      this.showAddQrCodeAttachmentStatus = true
    },
    async removeAttachment(attachmentType, repairFileId) {
      this.loading = true
      try {
        await RepairFileService.removeAttachmentFromRepairFile(
          repairFileId,
          attachmentType,
          $store.state.currentCollaborator.technical_id
        )
        displayToast(this.$t('COMMON.MESSAGE.REMOVE_ATTACHMENT_SUCCESS'), 'success')

        // Refresh currentRepairFile
        this.currentRepairFile = await RepairFileService.get(this.currentRepairFile.boomerang_id)
      } catch (error) {
        handleResponseError(error)
        if (error.response?.data && error.response.data.key in ResponseConstant) {
          this.setError(error.response.data.key)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
:deep(.v-selection-control__input > .v-icon) {
  color: #559a1b;
  opacity: unset;
}

:deep(.v-selection-control-group--inline) {
  margin: auto;
}

:deep(.logo-selector .v-field.v-field--appended) {
  justify-content: center !important;
  align-content: center;
}

:deep(.v-selection-control--inline .v-label) {
  opacity: unset;
}

.chip-container {
  margin-left: 0;
}

:deep(.clickable-chip .v-chip__append) {
  cursor: pointer;
}
</style>
